import React, { useState } from "react";
import { Popover } from "antd";
import { FiGlobe } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { cn } from "src/util/cn";

export const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const currentLanguage = i18n.language.toLowerCase();
  const isEnglish = currentLanguage.startsWith("en");
  const isItalian = currentLanguage.startsWith("it");

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    setIsVisible(false);
  };

  const popoverContent = (
    <div className="flex flex-col p-4 gap-y-3 select-none">
      <p
        className={cn("font-normal cursor-pointer m-0", {
          "text-primary": isEnglish,
        })}
        onClick={() => handleLanguageChange("en")}
      >
        English (UK)
      </p>
      <p
        className={cn("font-normal cursor-pointer m-0", {
          "text-primary": isItalian,
        })}
        onClick={() => handleLanguageChange("it")}
      >
        Italian (Italiano)
      </p>
      <p className="font-normal cursor-not-allowed opacity-[0.6] m-0">
        Romana (Romanian)
      </p>
      <p className="font-normal cursor-not-allowed opacity-[0.6] m-0">
        中国人 (Chinese)
      </p>
    </div>
  );

  return (
    <Popover
      content={popoverContent}
      trigger="click"
      placement="bottomRight"
      open={isVisible}
      onOpenChange={setIsVisible}
    >
      <div className="flex items-center gap-1.5 cursor-pointer mr-1 ml-2 select-none">
        <FiGlobe className="text-xl text-[#7D878C]" />
        <span className="text-sm font-medium text-[#7D878C]">
          {isItalian ? "It" : "En"}
        </span>
      </div>
    </Popover>
  );
};

export default LanguageSelector;
